import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck } from 'lucide-react';
// 👉 EDITÁ EL CONTENIDO DE ESTA SECCIÓN ABAJO
export const pricingContent = {
  title: 'Llevate todo el MegaPack hoy',
  subtitle: 'Un único pago. Acceso de por vida a los 6 tomos.',
  originalPrice: '$55.000',
  currentPrice: '$24.990',
  currency: 'ARS',
  features: ['Acceso inmediato a los 6 tomos clínicos', 'Te llevas 6 bonos exclusivos totalmente gratuitos', 'Fichas de observación y registros evolutivos editables', 'Material para estimular áreas sensoriales, motoras y de lenguaje', 'Actualizaciones futuras sin cargo', 'Bono: Guía de organización del consultorio'],
  ctaText: 'COMPRAR AHORA',
  // 👉 URL DE COMPRA
  ctaLink: 'https://habitandomicuerpo.shop/products/megapack-estimulacion-temprana-%E2%9C%A8',
  paymentNote: 'Pago seguro a través de MercadoPago / PayPal',
  guaranteeText: 'Garantía de satisfacción de 7 días. Si el material no es lo que esperabas, te devolvemos el 100% de tu dinero.'
};
export function Pricing() {
  return <section id="pricing" className="py-24 px-4 bg-[#0f0f0f] relative overflow-hidden" data-id="element-159">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-accent/10 rounded-full blur-[100px] pointer-events-none" data-id="element-160" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-161">
        <div className="text-center mb-12" data-id="element-162">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-5xl font-serif mb-4 text-brand-light" data-id="element-163">
            {pricingContent.title}
          </motion.h2>
          <p className="text-brand-light/70 font-sans" data-id="element-164">
            {pricingContent.subtitle}
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-brand-card border border-brand-accent/30 rounded-3xl p-8 md:p-12 shadow-2xl shadow-brand-accent/5" data-id="element-165">
          <div className="flex flex-col md:flex-row gap-12 items-center" data-id="element-166">
            <div className="flex-1 text-center md:text-left w-full" data-id="element-167">
              <div className="mb-8" data-id="element-168">
                <span className="text-brand-light/50 line-through text-xl font-sans block mb-2" data-id="element-169">
                  {pricingContent.originalPrice} {pricingContent.currency}
                </span>
                <div className="flex items-baseline justify-center md:justify-start gap-2" data-id="element-170">
                  <span className="text-5xl md:text-6xl font-serif font-bold text-brand-light" data-id="element-171">
                    {pricingContent.currentPrice}
                  </span>
                  <span className="text-brand-light/70 font-sans" data-id="element-172">
                    {pricingContent.currency}
                  </span>
                </div>
              </div>

              <ul className="space-y-4 mb-8" data-id="element-173">
                {pricingContent.features.map((feature, index) => <li key={index} className="flex items-center gap-3 text-brand-light/90 font-sans text-left" data-id="element-174">
                    <CheckCircle2 className="w-5 h-5 text-brand-accent shrink-0" data-id="element-175" />
                    <span data-id="element-176">{feature}</span>
                  </li>)}
              </ul>
            </div>

            <div className="flex-1 w-full flex flex-col items-center" data-id="element-177">
              <a href={pricingContent.ctaLink} target="_blank" rel="noopener noreferrer" className="w-full text-center bg-brand-accent hover:bg-brand-accentHover text-white font-semibold py-5 px-8 rounded-xl transition-all duration-300 transform hover:scale-105 shadow-[0_0_20px_rgba(153,27,27,0.3)] mb-4" data-id="element-178">
                {pricingContent.ctaText}
              </a>
              <p className="text-sm text-brand-light/50 font-sans mb-8 text-center" data-id="element-179">
                {pricingContent.paymentNote}
              </p>

              <div className="flex items-start gap-3 bg-brand-dark/50 p-4 rounded-xl border border-brand-cardBorder" data-id="element-180">
                <ShieldCheck className="w-6 h-6 text-emerald-500 shrink-0 mt-0.5" data-id="element-181" />
                <p className="text-xs text-brand-light/70 font-sans leading-relaxed" data-id="element-182">
                  {pricingContent.guaranteeText}
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}